import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-spinkit';

const ProcessingIndicator = ({ children }) => (
  <div className="c-processing-indicator">
    <h2 className="c-processing-indicator__text">{children}</h2>
    <div className="u-co-branding">
      <Spinner spinnerName="three-bounce" noFadeIn />
    </div>
  </div>
);
ProcessingIndicator.propTypes = {
  children: PropTypes.string,
};
ProcessingIndicator.defaultProps = {
  children: '',
};

export default ProcessingIndicator;



// WEBPACK FOOTER //
// ./src/app/reservation/components/ProcessingIndicator.jsx